var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-loading',{attrs:{"loading":_vm.page.loading}}),(!_vm.page.loading)?_c('div',[(!_vm.showErrorsWithObject && _vm.page.errors.length > 0)?_c('error-list',{attrs:{"errors":_vm.page.errors}}):_c('div',[(_vm.showErrorsWithObject)?_c('error-list',{attrs:{"errors":_vm.page.errors}}):_vm._e(),_vm._t("default")],2)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }